/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import React from "react"
import {
  Route,
  Routes,
  Navigate,
  Outlet,
  BrowserRouter as Router,
} from "react-router-dom"
import { Login, Loading } from "./modules"
import Container from "./modules/toms/container/Container"
import SessionTimeout from "./modules/base/errorPages/SessionTimeout"
import ErrorPage403 from "./modules/base/errorPages/ErrorPage403"
import "leaflet/dist/leaflet.css"

/*This function act as the protected route for pages, components that needs to load only if user logged in*/
const ProtectedRoute = ({ user, children }) => {
  const isLoggedin = localStorage.getItem("isLoggedin")
  if (isLoggedin !== "true") {
    return <Navigate to="/login" replace />
  }

  return children ? children : <Outlet />
}

const App = (props) => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
          <Route
            path="/app"
            element={<Navigate to="/app/dashboard" replace />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/loading" element={<Loading />} />

          <Route path="/sessionTimout" element={<SessionTimeout />} />
          <Route path="/ErrorPage403" element={<ErrorPage403 />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/app/*" element={<Container />} />
          </Route>
          <Route path="*" element={<p>There's nothing here: 404!</p>} />
        </Routes>
      </Router>
    </div>
  )
}

export default App
